import React, { useState } from 'react';
import { ChevronRight, ShieldAlert } from 'lucide-react';
import { SpamGuideSheet } from './SpamGuideSheet';

// 로그인 인증번호 단계 — 인증 문자를 보내자마자 입력칸 아래에 보이는 스팸함 안내 (대표 7685·7687, 2026-10-21)
// 문구는 대표 문장 그대로다. 입력을 가리지 않게 작게 두고, 코드를 넣기 시작해도 그대로 둔다.
// 인증 문자는 1544-4916(솔라피) 또는 해외 번호(트윌리오, +1로 시작)로 간다 — 자세한 안내 첫 줄에 적는다.
export const OtpSpamHint: React.FC = () => {
    const [guideOpen, setGuideOpen] = useState<boolean>(false);

    return (
        <>
            {/* 2026-11-03 새 디자인: 테두리 상자 → 옅은 면 한 장(글귀·동작 그대로) */}
            <div className="flex items-start gap-2.5 rounded-2xl bg-white/[0.04] px-4 py-3">
                <ShieldAlert className="mt-[3px] h-4 w-4 flex-shrink-0 text-[#FBBF24]" aria-hidden="true" />
                <p className="text-[13px] leading-relaxed text-[#A1A1AA]" style={{ wordBreak: 'keep-all' }}>
                    인증 문자가 10~20초 안에 오지 않으면, 혹시{' '}
                    <span className="font-semibold text-[#FFFFFF]">1544-4916</span> 번호를 스팸 처리해 놓진 않으셨나요? 스팸함을 확인해 주세요.{' '}
                    <button
                        type="button"
                        onClick={() => setGuideOpen(true)}
                        className="inline-flex items-center font-semibold text-[#FAFAFA] underline underline-offset-4 transition-colors hover:text-white"
                    >
                        자세히 보기
                        <ChevronRight className="h-3 w-3" aria-hidden="true" />
                    </button>
                </p>
            </div>
            <SpamGuideSheet open={guideOpen} onOpenChange={setGuideOpen} />
        </>
    );
};
